import { BaseDocumentBloc } from "./bloc.base";
import storage from "@/storage";
import environment from '@/config';
import { apiNet } from '@cems-eco/core/src/services/api';
import { UploadRequest, Document } from "./model";

export class CloudDocumentBloc extends BaseDocumentBloc {
    public get base_url() {
        const site = storage.getSync<any>(storage.SITE);
        return `/document?hash=${site.hash}`;
    }


    getDocUrl(endpoint) {
        const site = storage.getSync<any>(storage.SITE);
        return `${environment.PROXY_API_URL}/${endpoint}?hash=${site.hash}`;
    }

    getTableUrl(management_id) {
        const params = {
            search: {
                advanced: {
                    management_id
                }
            },
            orderBy: {
                created_at: "desc"
            },
            with: "user"
        }
        return apiNet.getUrl(this.base_url, params);
    }
}

